// extracted by mini-css-extract-plugin
export var boardmemberdetail = "BoardMemberDetail-module--boardmemberdetail--ce3d8";
export var contentContainer = "BoardMemberDetail-module--contentContainer--45143";
export var imageContainer = "BoardMemberDetail-module--imageContainer--dab91";
export var name = "BoardMemberDetail-module--name--ae968";
export var reverse = "BoardMemberDetail-module--reverse--9a436";
export var textContainer = "BoardMemberDetail-module--textContainer--c254d";
export var title = "BoardMemberDetail-module--title--15fd3";